import { getApi } from '@coconut/services/apis/utils';

export const fetchQuestionQuotaApi = (userId) =>
  getApi(`api/v2/students/${userId}/quotas`).then((res) => res);



// WEBPACK FOOTER //
// ./src/services/apis/questionQuota.js